import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Data } from '@angular/router';
import { AuthService } from "@core/auth.service";
import { Subscription, switchMap } from 'rxjs';
import { JackpotTriggersService } from "src/app/services/jackpot-triggers.service";
import { Router } from "@angular/router";
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-selected-gold-ring-locked',
  standalone: true,
  imports: [],
  templateUrl: './selected-gold-ring-locked.component.html',
  styleUrl: './selected-gold-ring-locked.component.scss'
})
export class SelectedGoldRingLockedComponent {
  languageCode: string = "en";
  goodLuckPopupTranslatedData: any;
  closeButton: string;
  description: string;
  title: string;
  userDetailsSub:Subscription;

  constructor(
    private matDialog: MatDialog,
    private matDialogRef: MatDialogRef<SelectedGoldRingLockedComponent>,
    private jackpotTriggerService: JackpotTriggersService,
    private authService: AuthService,
    private router: Router,
    private modalCtrl: ModalController,
  ) {
    this.matDialogRef.disableClose = true;
  }

  ngOnInit() {
    this.userDetailsSub = this.authService?.userDetails$?.pipe(
      switchMap((user: Data) => {
        this.languageCode = user?.language_code ? user?.language_code : "en";
        return this.jackpotTriggerService?.getTranslatedData(this.languageCode);
      })
    ).subscribe({
      next: (data) => {
        this.goodLuckPopupTranslatedData = data?.["gold_rings_good_luck_popup"];
        this.closeButton = this.goodLuckPopupTranslatedData?.close_button;
        this.description = this.goodLuckPopupTranslatedData?.description;
        this.title = this.goodLuckPopupTranslatedData?.title;
      },
      error: (err) => {
        return err;
      }
    });
  }

  closePopup() {
    this.matDialog.closeAll();
    this.modalCtrl.dismiss(true).catch((err) => {
      return err;
    });
    this.router.navigateByUrl("mainTabs/tabs/syndicate");
  }

  ngOnDestroy(){
    this.userDetailsSub?.unsubscribe();
  }
}
